import { takeEvery, call, put } from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import actions from '../constants';
import DatasetDataManagementService from '../service';
import {
  convertDatasetDataError,
  convertDatasetDataSuccess,
  convertDictionaryDataError,
  convertDictionaryDataSuccess,
  validateDatasetDataError,
  validateDatasetDataSuccess,
  validateDictionaryDataError,
  validateDictionaryDataSuccess,
} from '../actions';

export function* convertDataset({ category, code, name }) {
  const { response, error } = yield call(callAdapter, DatasetDataManagementService.convertDataset(code));
  if (error) {
    yield put(convertDatasetDataError(category, code, name, error));
  } else {
    yield put(convertDatasetDataSuccess(category, code, name, response));
  }
}

export function* convertDictionary(action) {
  const { response, error } = yield call(
    callAdapter,
    DatasetDataManagementService.convertDictionary(action.dictionaryCode),
  );

  if (error) {
    yield put(convertDictionaryDataError(
      action.category,
      action.code,
      action.dictionaryCode,
      action.dictionaryName,
      error,
    ));
  } else {
    yield put(convertDictionaryDataSuccess(
      action.category,
      action.code,
      action.dictionaryCode,
      action.dictionaryName,
      response,
    ));
  }
}

export function* validateDataset({ category, code }) {
  const { response, error } = yield call(callAdapter, DatasetDataManagementService.validateDataset(code));
  if (error) {
    yield put(validateDatasetDataError(category, code, error));
  } else {
    yield put(validateDatasetDataSuccess(category, code, response));
  }
}

export function* validateDictionary({ category, code, dictionaryCode }) {
  const { response, error } = yield call(
    callAdapter,
    DatasetDataManagementService.validateDictionary(dictionaryCode),
  );
  if (error) {
    yield put(validateDictionaryDataError(category, code, dictionaryCode, error));
  } else {
    yield put(validateDictionaryDataSuccess(category, code, dictionaryCode, response));
  }
}

export default function* datasetDataManagementApi() {
  yield takeEvery(actions.CONVERT_DATASET_DATA, convertDataset);
  yield takeEvery(actions.CONVERT_DICTIONARY_DATA, convertDictionary);
  yield takeEvery(actions.VALIDATE_DATASET_DATA, validateDataset);
  yield takeEvery(actions.VALIDATE_DICTIONARY_DATA, validateDictionary);
}
